.wrapper {
  flex-direction: column;
  height: 100%;
}

.companies-content {
  flex-grow: 2;
  height: 100%;

  .companies-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;

    header-buttons {
      padding-right: calc(2 * var(--spacer));
      margin-right: calc(2 * var(--spacer));
      position: relative;
    }

    .inline-block {
      display: inline-block;
    }

    .company-action-split-button-text,
    .action-icon {
      vertical-align: middle;
    }

    .action-icon {
      display: inline-block;

      &:before {
        font-size: 32px;
      }
    }

    gz-button[class='action-split-button']::part(button) {
      padding-right: var(--spacer);
    }
  }
}
